import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { Bounce } from "../Bounce/Bounce";
import { CollisionsOverlap } from "./CollisionsOverlap";
export var Collisions = /*#__PURE__*/function () {
  function Collisions() {
    _classCallCheck(this, Collisions);
    this.bounce = new Bounce();
    this.enable = false;
    this.mode = "bounce";
    this.overlap = new CollisionsOverlap();
  }
  _createClass(Collisions, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      this.bounce.load(data.bounce);
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      this.overlap.load(data.overlap);
    }
  }]);
  return Collisions;
}();